import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import GeneralButton from '../../mainComponents/generalButton';
import CustomAppBar from '../../mainComponents/appBar';
import BigTitle from '../../mainComponents/bigTitle';
import { updateRegistrationData } from '../../utils/localStorageHelper';

export default function ChooseUserName() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('@');

  const handleUsernameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === '') {
      setUsername('@');
    } else if (value.startsWith('@')) {
      setUsername(value);
    } else {
      setUsername('@' + value.replace('@', ''));
    }
  };

  function handleContinue(): void {
    const toastId = 'username-error';
  
    if (!username || username === '@') {
      toast.error('Username cannot be empty.', {
        id: toastId,
      });
      return;
    }
  
    toast.dismiss(toastId); 
    updateRegistrationData({ username: username.replace('@', '') });
    navigate("/profilepicture");
  }
  
  return (
    <div className="flex flex-col items-center justify-between pt-10 h-screen overflow-hidden bg-[#1a2630] text-white p-5 font-custom">
      <CustomAppBar />

      <div className="w-full max-w-sm space-y-10">
        <div className="text-center">
          <BigTitle text={'Choose a'} />
          <BigTitle text={'username'} />
        </div>

        <div className="flex items-center justify-center py-4 rounded-full w-full cursor-pointer transition-all bg-white bg-opacity-10">
          <div className="flex items-center space-x-4 w-full">
            <input
              type="text"
              className="bg-transparent outline-none text-white placeholder-gray-400 text-2xl text-center w-full"
              placeholder="Enter your username"
              value={username}
              onChange={handleUsernameChange}
            />
          </div>
        </div>

        <GeneralButton text={'Continue'} color={'white'} onClick={handleContinue} />
      </div>

      <div className="h-1" />
    </div>
  );
}
